<template>
  <section id="baubegleitung">
    <v-container>
      <v-row justify="center">
        <h2 class="section-title">{{ lang.baubegleitung.caption }}</h2>
      </v-row>

      <v-timeline side="end" class="hidden-md-and-up mt-10">
        <v-timeline-item v-for="(item, index) in lang.baubegleitung.items" :key="index" :dot-color="'primary'" :icon="item.icon">
          <template v-slot:opposite>
            <div class="pt-1 headline font-weight-bold"></div>
          </template>
          <v-card>
            <h3 class="text-h6 font-weight-medium mb-2">{{ item.caption }}</h3>
            <p>{{ item.description }}</p>
          </v-card>
        </v-timeline-item>
      </v-timeline>

      <v-timeline class="hidden-sm-and-down mt-10">
        <v-timeline-item v-for="(item, index) in lang.baubegleitung.items" :key="index" :dot-color="'primary'" :icon="item.icon">
          <template v-slot:opposite>
            <div class="pt-1 headline font-weight-bold"></div>
          </template>
          <v-card :style="index % 2 === 0 ? '' : 'float: right'">
            <h3 class="text-h6 font-weight-medium mb-2">{{ item.caption }}</h3>
            <p>{{ item.description }}</p>
          </v-card>
        </v-timeline-item>
      </v-timeline>

      <v-row justify="center" class="mt-10">
        <v-btn size="large" class="text-white primary" href="#contact">
          {{ lang.baubegleitung.button_to_contact_link }}
        </v-btn>
      </v-row>
    </v-container>
  </section>
</template>

<style>
.v-timeline-divider__inner-dot.bg-primary {
  background-color: var(--primary) !important;
}
</style>

<script>
import lang from '@/lang/lang.js'

export default {
  data() {
    return {
      lang: lang,
    }
  }
}
</script>